// import React, { useState } from 'react';

// const BeforeAfterSimplifyte = () => {
//   const [isTransformed, setIsTransformed] = useState(false)
//   const HandleClick = () => {
//     setIsTransformed(!isTransformed)
//   }
//   return (
//     <div className="team-collaboration-container">
//       <div className="team-collaboration-content">
//         {/* Header Section */}
//         <div className="team-collaboration-header">
//           <div className="team-collaboration-badge">
//             <div className="badge-icon-wrapper">
//               <svg className="badge-icon-rotate" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                 <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
//                 <path d="M16 3.128a4 4 0 0 1 0 7.744" />
//                 <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
//                 <circle cx="9" cy="7" r="4" />
//               </svg>
//             </div>
//             <span className="badge-text">The Transformation</span>
//           </div>

//           <h2 className="team-collaboration-title">From Chaos to Clarity</h2>
//           <p className="team-collaboration-subtitle">
//             See how Simplifyte transforms scattered teams into synchronized powerhouses
//           </p>
//         </div>

//         {/* Comparison Grid */}
//         <div className="comparison-grid">
//           {/* Before Section */}
//           <div className="comparison-card before-card">
//             <div className="floating-dots">
//               {[...Array(20)].map((_, i) => (
//                 <div key={i} className="dot dot-red" style={{
//                   left: `${Math.random() * 100}%`,
//                   top: `${Math.random() * 100}%`,
//                   animationDelay: `${Math.random() * 5}s`
//                 }} />
//               ))}
//             </div>

//             <div className="card-badge badge-before">
//               <svg className="badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                 <circle cx="12" cy="12" r="10" />
//                 <line x1="12" x2="12" y1="8" y2="12" />
//                 <line x1="12" x2="12.01" y1="16" y2="16" />
//               </svg>
//               <span className="badge-text">BEFORE: Without Simplifyte</span>
//             </div>

//             <h3 className="card-title">The Scattered Team</h3>
//             <p className="card-subtitle before-subtitle">Everyone working in silos</p>

//             {/* Team Avatars */}
//             <div className="avatars-container before-avatars">
//               <div className="avatar-item" style={{ left: '15%', top: '20%' }}>
//                 <div className="avatar avatar-pink">AM</div>
//                 <div className="avatar-alert">?</div>
//               </div>
//               <div className="avatar-item" style={{ left: '65%', top: '15%' }}>
//                 <div className="avatar avatar-purple">BK</div>
//                 <div className="avatar-alert">?</div>
//               </div>
//               <div className="avatar-item" style={{ left: '25%', top: '55%' }}>
//                 <div className="avatar avatar-blue">CL</div>
//                 <div className="avatar-alert">?</div>
//               </div>
//               <div className="avatar-item" style={{ left: '75%', top: '65%' }}>
//                 <div className="avatar avatar-green">DN</div>
//                 <div className="avatar-alert">?</div>
//               </div>
//               <div className="avatar-item" style={{ left: '45%', top: '30%' }}>
//                 <div className="avatar avatar-yellow">EP</div>
//                 <div className="avatar-alert">?</div>
//               </div>
//               <div className="avatar-item" style={{ left: '85%', top: '40%' }}>
//                 <div className="avatar avatar-red">FR</div>
//                 <div className="avatar-alert">?</div>
//               </div>
//               <div className="avatar-item" style={{ left: '10%', top: '75%' }}>
//                 <div className="avatar avatar-indigo">GS</div>
//                 <div className="avatar-alert">?</div>
//               </div>
//               <div className="avatar-item" style={{ left: '55%', top: '80%' }}>
//                 <div className="avatar avatar-cyan">HT</div>
//                 <div className="avatar-alert">?</div>
//               </div>

//               {/* Connection Lines */}
//               <svg className="connection-lines">
//                 <line x1="15%" y1="20%" x2="65%" y2="15%" stroke="#EF4444" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" />
//                 <line x1="25%" y1="55%" x2="75%" y2="65%" stroke="#F97316" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" />
//                 <line x1="45%" y1="30%" x2="85%" y2="40%" stroke="#EF4444" strokeWidth="2" strokeDasharray="5,5" opacity="0.4" />
//               </svg>
//             </div>

//             {/* Speech Bubbles */}
//             <div className="speech-bubbles">
//               <div className="speech-bubble left-bubble">
//                 <svg className="bubble-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
//                 </svg>
//                 <span>Who's doing what?</span>
//               </div>
//               <div className="speech-bubble right-bubble">
//                 <svg className="bubble-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
//                   <path d="M12 17h.01" />
//                   <path d="M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" />
//                 </svg>
//                 <span>Where's the file?</span>
//               </div>
//             </div>

//             {/* Stats Grid */}
//             <div className="stats-grid before-stats">
//               <div className="stat-card stat-card-red">
//                 <div className="stat-value">73%</div>
//                 <div className="stat-label">Tasks Unclear</div>
//               </div>
//               <div className="stat-card stat-card-orange">
//                 <div className="stat-value">12hrs</div>
//                 <div className="stat-label">Wasted/Week</div>
//               </div>
//               <div className="stat-card stat-card-red">
//                 <div className="stat-value">5</div>
//                 <div className="stat-label">Different Tools</div>
//               </div>
//               <div className="stat-card stat-card-orange">
//                 <div className="stat-value">28</div>
//                 <div className="stat-label">Unread Messages</div>
//               </div>
//             </div>
//           </div>

//           {/* After Section */}
//           <div className="comparison-card after-card">
//             <div className="floating-dots">
//               {[...Array(20)].map((_, i) => (
//                 <div key={i} className="dot dot-blue" style={{
//                   left: `${Math.random() * 100}%`,
//                   top: `${Math.random() * 100}%`,
//                   animationDelay: `${Math.random() * 5}s`
//                 }} />
//               ))}
//             </div>

//             <div className="card-badge badge-after">
//               <svg className="badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                 <circle cx="12" cy="12" r="10" />
//                 <path d="m9 12 2 2 4-4" />
//               </svg>
//               <span className="badge-text">AFTER: With Simplifyte</span>
//             </div>

//             <h3 className="card-title">The Aligned Team</h3>
//             <p className="card-subtitle after-subtitle">Everyone in perfect sync</p>

//             {/* Team Avatars - Connected */}
//             <div className="avatars-container after-avatars">
//               <div className="avatar-item-center" style={{ left: '50%', top: '50%' }}>
//                 <div className="avatar avatar-cyan pulse-effect">HT</div>
//                 <div className="success-badge">
//                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                     <circle cx="12" cy="12" r="10" />
//                     <path d="m9 12 2 2 4-4" />
//                   </svg>
//                 </div>
//               </div>
//               <div className="avatar-item" style={{ left: '50%', top: '20%' }}>
//                 <div className="avatar avatar-pink glow-effect">AM</div>
//               </div>
//               <div className="avatar-item" style={{ left: '73%', top: '35%' }}>
//                 <div className="avatar avatar-purple glow-effect">BK</div>
//               </div>
//               <div className="avatar-item" style={{ left: '80%', top: '60%' }}>
//                 <div className="avatar avatar-blue glow-effect">CL</div>
//               </div>
//               <div className="avatar-item" style={{ left: '65%', top: '80%' }}>
//                 <div className="avatar avatar-green glow-effect">DN</div>
//               </div>
//               <div className="avatar-item" style={{ left: '35%', top: '80%' }}>
//                 <div className="avatar avatar-yellow glow-effect">EP</div>
//               </div>
//               <div className="avatar-item" style={{ left: '20%', top: '60%' }}>
//                 <div className="avatar avatar-red glow-effect">FR</div>
//               </div>
//               <div className="avatar-item" style={{ left: '27%', top: '35%' }}>
//                 <div className="avatar avatar-indigo glow-effect">GS</div>
//               </div>

//               {/* Connection Lines */}
//               <svg className="connection-lines">
//                 <defs>
//                   <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="0%">
//                     <stop offset="0%" stopColor="#3B82F6" />
//                     <stop offset="100%" stopColor="#8B5CF6" />
//                   </linearGradient>
//                 </defs>
//                 <line x1="50%" y1="50%" x2="50%" y2="20%" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.6" />
//                 <line x1="50%" y1="50%" x2="73%" y2="35%" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.6" />
//                 <line x1="50%" y1="50%" x2="80%" y2="60%" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.6" />
//                 <line x1="50%" y1="50%" x2="65%" y2="80%" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.6" />
//                 <line x1="50%" y1="50%" x2="35%" y2="80%" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.6" />
//                 <line x1="50%" y1="50%" x2="20%" y2="60%" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.6" />
//                 <line x1="50%" y1="50%" x2="27%" y2="35%" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.6" />
//               </svg>

//               <div className="center-sparkle">
//                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
//                 </svg>
//               </div>
//             </div>

//             {/* Success Messages */}
//             <div className="speech-bubbles">
//               <div className="speech-bubble left-bubble-success">
//                 <svg className="bubble-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <circle cx="12" cy="12" r="10" />
//                   <path d="m9 12 2 2 4-4" />
//                 </svg>
//                 <span>Crystal clear!</span>
//               </div>
//               <div className="speech-bubble right-bubble-success">
//                 <svg className="bubble-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                   <circle cx="12" cy="12" r="10" />
//                   <circle cx="12" cy="12" r="6" />
//                   <circle cx="12" cy="12" r="2" />
//                 </svg>
//                 <span>On schedule!</span>
//               </div>
//             </div>

//             {/* Stats Grid */}
//             <div className="stats-grid after-stats">
//               <div className="stat-card stat-card-blue">
//                 <div className="stat-value">100%</div>
//                 <div className="stat-label">Task Visibility</div>
//               </div>
//               <div className="stat-card stat-card-purple">
//                 <div className="stat-value">10hrs</div>
//                 <div className="stat-label">Saved/Week</div>
//               </div>
//               <div className="stat-card stat-card-cyan">
//                 <div className="stat-value">1</div>
//                 <div className="stat-label">Unified Platform</div>
//               </div>
//               <div className="stat-card stat-card-green">
//                 <div className="stat-value">Real-time</div>
//                 <div className="stat-label">Sync</div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* CTA Button */}
//         <div className="cta-container">
//           <button className={`cta-button ${isTransformed ? 'transformed' : ''}`}
//             onClick={HandleClick}>
//             <div className="button-glow"></div>
//             <span className="button-content">
//               <svg className="button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                 <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
//               </svg>
//               Watch The Transformation
//               <svg className="button-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                 <path d="M5 12h14" />
//                 <path d="m12 5 7 7-7 7" />
//               </svg>
//             </span>
//             <div className="button-particles">
//               {[...Array(8)].map((_, i) => (
//                 <div key={i} className="particle" style={{
//                   left: `${10 + i * 12}%`,
//                   animationDelay: `${i * 0.1}s`
//                 }} />
//               ))}
//             </div>
//           </button>
//         </div>
//         {isTransformed && (
//           <div className="transformation-success">
//             <h3 style={{ margin: 0, color: '#3B82F6' }}>✨ Team Aligned! Perfect synchronization achieved ✨</h3>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BeforeAfterSimplifyte;

import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import {
  Users,
  AlertCircle,
  CheckCircle2,
  Clock,
  MessageSquare,
  FileQuestion,
  Sparkles,
  ArrowRight,
  Zap,
  Target,
  X as XIcon,
  User,
} from "lucide-react";
// TeamCollaboration.css 392 starting

export default function TeamBeforeAfter() {
  const [showTransformation, setShowTransformation] = useState(false);
  const [transformationComplete, setTransformationComplete] = useState(false);

  const handleTransform = () => {
    setShowTransformation(true);
    setTransformationComplete(false);

    // Auto-close after animation completes
    setTimeout(() => {
      setTransformationComplete(true);
      setTimeout(() => {
        setShowTransformation(false);
        setTransformationComplete(false);
      }, 1500);
    }, 4000);
  };

  // Team member data
  const teamMembers = [
    { id: 1, name: "AM", color: "from-pink-500 to-rose-500" },
    { id: 2, name: "BK", color: "from-purple-500 to-indigo-500" },
    { id: 3, name: "CL", color: "from-blue-500 to-cyan-500" },
    { id: 4, name: "DN", color: "from-green-500 to-emerald-500" },
    { id: 5, name: "EP", color: "from-yellow-500 to-orange-500" },
    { id: 6, name: "FR", color: "from-red-500 to-pink-500" },
    { id: 7, name: "GS", color: "from-indigo-500 to-purple-500" },
    { id: 8, name: "HT", color: "from-cyan-500 to-blue-500" },
  ];

  // Scattered positions for "BEFORE" state
  const scatteredPositions = [
    { x: "15%", y: "20%" },
    { x: "65%", y: "15%" },
    { x: "25%", y: "55%" },
    { x: "75%", y: "65%" },
    { x: "45%", y: "30%" },
    { x: "85%", y: "40%" },
    { x: "10%", y: "75%" },
    { x: "55%", y: "80%" },
  ];

  // Organized circular positions for "AFTER" state
  const organizedPositions = [
    { x: "50%", y: "20%" }, // Top
    { x: "73%", y: "35%" }, // Top-right
    { x: "80%", y: "60%" }, // Right
    { x: "65%", y: "80%" }, // Bottom-right
    { x: "35%", y: "80%" }, // Bottom-left
    { x: "20%", y: "60%" }, // Left
    { x: "27%", y: "35%" }, // Top-left
    { x: "50%", y: "50%" }, // Center (manager)
  ];

  return (
    <div className="team-collaboration-container">
      {/* Section Header */}
      <div className="text-center mb-16 relative z-10">
        <motion.div
          className="inline-block px-6 py-3 bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-900 rounded-full mb-6 shadow-lg"
          initial={{ opacity: 0, scale: 0.95, y: -20 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{
            duration: 1.2,
            type: "spring",
            stiffness: 100,
            damping: 15,
          }}
        >
          <span className="flex items-center gap-3">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            >
              <Users className="w-5 h-5" />
            </motion.div>
            <span className="badge-text">The Transformation</span>
          </span>
        </motion.div>

        <motion.h2
          className="team-collaboration-title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          From Chaos to Clarity
        </motion.h2>
        {/* TeamBeforeAfter i have Given 487 this css in TeamCollaboration ok see down also i have given name*/}
        <motion.p
          className="TeamBeforeAfter_SubTitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          See how Simplifyte transforms scattered teams into synchronized
          powerhouses
        </motion.p>
      </div>

      {/* Main Comparison Container */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-7xl mx-auto"
      >
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* ===== LEFT PANEL: BEFORE (CHAOS) ===== */}
          <motion.div
            // relative bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 rounded-3xl
            //  p-8 border-2 border-red-200 shadow-xl overflow-hidden min-h-[600px]
            className="TeamBeforeAfter_Scattered"
            whileHover="hover"
            initial="initial"
            variants={{
              initial: {},
              hover: {},
            }}
          >
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-10">
              {[...Array(20)].map((_, i) => (
                <motion.div
                  key={i}
                  className="absolute w-2 h-2 bg-red-500 rounded-full"
                  style={{
                    left: `${Math.random() * 100}%`,
                    top: `${Math.random() * 100}%`,
                  }}
                  animate={{
                    y: [0, -10, 0],
                    opacity: [0.3, 0.6, 0.3],
                  }}
                  transition={{
                    duration: 2 + Math.random(),
                    repeat: Infinity,
                    delay: Math.random() * 2,
                  }}
                />
              ))}
            </div>

            {/* Header Badge */}
            <motion.div
              className="inline-flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded-full mb-6 shadow-lg"
              animate={{
                boxShadow: [
                  "0 4px 20px rgba(239, 68, 68, 0.3)",
                  "0 4px 30px rgba(239, 68, 68, 0.5)",
                  "0 4px 20px rgba(239, 68, 68, 0.3)",
                ],
              }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <AlertCircle className="w-5 h-5" />
              <span className="font-semibold">BEFORE: Without Simplifyte</span>
            </motion.div>

            <h3 className="text-gray-900 mb-2">The Scattered Team</h3>
            <p className="text-red-700 mb-8">Everyone working in silos</p>

            {/* Scattered Team Members - Relative positioning */}
            <div className="relative h-80 mb-8">
              {teamMembers.map((member, index) => (
                <motion.div
                  key={member.id}
                  className="absolute"
                  style={{
                    left: scatteredPositions[index].x,
                    top: scatteredPositions[index].y,
                    transform: "translate(-50%, -50%)",
                  }}
                  variants={{
                    initial: { rotate: 0 },
                    hover: {
                      rotate: [0, -3, 3, -3, 0],
                      y: [0, -2, 2, -2, 0],
                    },
                  }}
                  transition={{ duration: 0.5, repeat: Infinity }}
                >
                  <motion.div
                    className={`w-14 h-14 rounded-full bg-gradient-to-br ${member.color} flex items-center justify-center text-white font-semibold shadow-lg border-2 border-white`}
                    whileHover={{ scale: 1.1 }}
                  >
                    {member.name}
                  </motion.div>
                  <motion.div
                    className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white text-xs"
                    animate={{ scale: [1, 1.2, 1] }}
                    transition={{ duration: 1, repeat: Infinity }}
                  >
                    ?
                  </motion.div>
                </motion.div>
              ))}

              <svg
                className="absolute inset-0 w-full h-full pointer-events-none"
                style={{ zIndex: 0 }}
              >
                <motion.line
                  x1="15%"
                  y1="20%"
                  x2="65%"
                  y2="15%"
                  stroke="#EF4444"
                  strokeWidth="2"
                  strokeDasharray="5,5"
                  opacity="0.4"
                  animate={{ strokeDashoffset: [0, 10] }}
                  transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                />
                <motion.line
                  x1="25%"
                  y1="55%"
                  x2="75%"
                  y2="65%"
                  stroke="#F97316"
                  strokeWidth="2"
                  strokeDasharray="5,5"
                  opacity="0.4"
                  animate={{ strokeDashoffset: [0, 10] }}
                  transition={{
                    duration: 1.2,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                />
                <motion.line
                  x1="45%"
                  y1="30%"
                  x2="85%"
                  y2="40%"
                  stroke="#EF4444"
                  strokeWidth="2"
                  strokeDasharray="5,5"
                  opacity="0.4"
                  animate={{ strokeDashoffset: [0, 10] }}
                  transition={{
                    duration: 0.8,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                />
              </svg>
            </div>

            {/* Floating task warnings */}
            <div className="relative h-20 mb-6">
              <motion.div
                className="absolute left-0 top-0 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-md border border-red-200 text-sm flex items-center gap-2"
                animate={{ y: [0, -5, 0], rotate: [-2, 0, -2] }}
                transition={{ duration: 3, repeat: Infinity }}
              >
                <MessageSquare className="w-4 h-4 text-red-500" />
                <span className="text-gray-700">Who's doing what?</span>
              </motion.div>

              <motion.div
                className="absolute right-0 top-0 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-md border border-orange-200 text-sm flex items-center gap-2"
                animate={{ y: [0, 5, 0], rotate: [2, 0, 2] }}
                transition={{ duration: 2.5, repeat: Infinity }}
              >
                <FileQuestion className="w-4 h-4 text-orange-500" />
                <span className="text-gray-700">Where's the file?</span>
              </motion.div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4">
              <motion.div
                className="Class_Different_Tools"
                whileHover={{ scale: 1.05, borderColor: "#EF4444" }}
              >
                <div className="Class_Different_Tools_CountPer">73%</div>
                <div className="text-sm text-gray-600">Tasks Unclear</div>
              </motion.div>
              <motion.div
                className="Class_Wasted_Week "
                whileHover={{ scale: 1.05, borderColor: "#F97316" }}
              >
                <div className="Class_Wasted_Week_CountPer_hrs">12hrs</div>
                <div className="text-sm text-gray-600">Wasted/Week</div>
              </motion.div>
              <motion.div
                className="Class_Different_Tools"
                whileHover={{ scale: 1.05, borderColor: "#EF4444" }}
              >
                <div className="Class_Different_Tools_CountPer">5</div>
                <div className="text-sm text-gray-600">Different Tools</div>
              </motion.div>
              <motion.div
                className="Class_Wasted_Week "
                whileHover={{ scale: 1.05, borderColor: "#F97316" }}
              >
                <div className="Class_Wasted_Week_CountPer_hrs">28</div>
                <div className="text-sm text-gray-600">Unread Messages</div>
              </motion.div>
            </div>
          </motion.div>

          {/* ===== RIGHT PANEL: AFTER (ORGANIZED) ===== */}
          <motion.div
            className="relative bg-gradient-to-br from-blue-50 via-purple-50 to-cyan-50 rounded-3xl p-8 border-2 border-blue-200 shadow-xl overflow-hidden min-h-[600px]"
            whileHover="hover"
            initial="initial"
            variants={{
              initial: {},
              hover: {},
            }}
          >
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-10">
              {[...Array(20)].map((_, i) => (
                <motion.div
                  key={i}
                  className="absolute w-2 h-2 bg-blue-500 rounded-full"
                  style={{
                    left: `${Math.random() * 100}%`,
                    top: `${Math.random() * 100}%`,
                  }}
                  animate={{
                    scale: [1, 1.5, 1],
                    opacity: [0.3, 0.6, 0.3],
                  }}
                  transition={{
                    duration: 2 + Math.random(),
                    repeat: Infinity,
                    delay: Math.random() * 2,
                  }}
                />
              ))}
            </div>

            {/* Header Badge */}
            <motion.div
              className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full mb-6 shadow-lg"
              animate={{
                boxShadow: [
                  "0 4px 20px rgba(59, 130, 246, 0.3)",
                  "0 4px 30px rgba(59, 130, 246, 0.5)",
                  "0 4px 20px rgba(59, 130, 246, 0.3)",
                ],
              }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <CheckCircle2 className="w-5 h-5" />
              <span className="font-semibold">AFTER: With Simplifyte</span>
            </motion.div>

            <h3 className="text-gray-900 mb-2">The Aligned Team</h3>
            <p className="text-blue-700 mb-8">Everyone in perfect sync</p>

            {/* Organized Team Members - Circular formation */}
            <div className="relative h-80 mb-8">
              {teamMembers.map((member, index) => (
                <motion.div
                  key={member.id}
                  className="absolute"
                  style={{
                    left: organizedPositions[index].x,
                    top: organizedPositions[index].y,
                    transform: "translate(-50%, -50%)",
                  }}
                  variants={{
                    initial: { scale: 1 },
                    hover: {
                      scale: [1, 1.05, 1],
                    },
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    delay: index * 0.1,
                  }}
                >
                  <motion.div
                    className={`w-14 h-14 rounded-full bg-gradient-to-br ${member.color} flex items-center justify-center text-white font-semibold shadow-lg border-2 border-white relative overflow-hidden`}
                    whileHover={{ scale: 1.15 }}
                  >
                    {member.name}
                    {/* Glow effect */}
                    <motion.div
                      className="absolute inset-0 bg-white/30"
                      animate={{
                        opacity: [0, 0.5, 0],
                      }}
                      transition={{
                        duration: 2,
                        repeat: Infinity,
                        delay: index * 0.2,
                      }}
                    />
                  </motion.div>
                  {/* Success indicator */}
                  {index === 7 && (
                    <motion.div
                      className="absolute -top-2 -right-2 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white"
                      animate={{ scale: [1, 1.2, 1], rotate: [0, 360] }}
                      transition={{ duration: 2, repeat: Infinity }}
                    >
                      <CheckCircle2 className="w-4 h-4" />
                    </motion.div>
                  )}
                </motion.div>
              ))}

              {/* Clean hub-spoke connection lines */}
              <svg
                className="absolute inset-0 w-full h-full pointer-events-none"
                style={{ zIndex: 0 }}
              >
                {organizedPositions.slice(0, 7).map((pos, index) => (
                  <motion.line
                    key={index}
                    x1="50%"
                    y1="50%"
                    x2={pos.x}
                    y2={pos.y}
                    stroke="url(#blueGradient)"
                    strokeWidth="2"
                    opacity="0.6"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 1.5, delay: index * 0.1 }}
                  />
                ))}
                <defs>
                  <linearGradient
                    id="blueGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop offset="0%" stopColor="#3B82F6" />
                    <stop offset="100%" stopColor="#8B5CF6" />
                  </linearGradient>
                </defs>
              </svg>

              {/* Center sparkle */}
              <motion.div
                className="absolute"
                style={{
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                animate={{
                  scale: [1, 1.3, 1],
                  rotate: 360,
                }}
                transition={{ duration: 3, repeat: Infinity }}
              >
                <Sparkles className="w-6 h-6 text-purple-600" />
              </motion.div>
            </div>

            {/* Success messages */}
            <div className="relative h-20 mb-6">
              <motion.div
                className="absolute left-0 top-0 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-md border border-green-200 text-sm flex items-center gap-2"
                animate={{ y: [0, -5, 0] }}
                transition={{ duration: 3, repeat: Infinity }}
              >
                <CheckCircle2 className="w-4 h-4 text-green-500" />
                <span className="text-gray-700">Crystal clear!</span>
              </motion.div>

              <motion.div
                className="absolute right-0 top-0 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-md border border-blue-200 text-sm flex items-center gap-2"
                animate={{ y: [0, 5, 0] }}
                transition={{ duration: 2.5, repeat: Infinity }}
              >
                <Target className="w-4 h-4 text-blue-500" />
                <span className="text-gray-700">On schedule!</span>
              </motion.div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4">
              <motion.div
                className="Class_Different_Tools"
                whileHover={{ scale: 1.05, borderColor: "#3B82F6" }}
              >
                <div className="Class_Simplifyte_way">100%</div>
                <div className="text-sm text-gray-600">Task Visibility</div>
              </motion.div>
              <motion.div
                className="bg-white/80 backdrop-blur-sm rounded-xl p-4 border border-purple-200"
                whileHover={{ scale: 1.05, borderColor: "#8B5CF6" }}
              >
                <div className="Class_Simplifyte_way_saved">10hrs</div>
                <div className="text-sm text-gray-600">Saved/Week</div>
              </motion.div>
              <motion.div
                className="bg-white/80 backdrop-blur-sm rounded-xl p-4 border border-cyan-200"
                whileHover={{ scale: 1.05, borderColor: "#06B6D4" }}
              >
                <div className="Class_Cyan_One">1</div>
                <div className="text-sm text-gray-600">Unified Platform</div>
              </motion.div>
              <motion.div
                className="bg-white/80 backdrop-blur-sm rounded-xl p-4 border border-green-200"
                whileHover={{ scale: 1.05, borderColor: "#10B981" }}
              >
                <div className="Class_Cyan_Time">Real-time</div>
                <div className="text-sm text-gray-600">Sync</div>
              </motion.div>
            </div>
          </motion.div>
        </div>

        {/* Center Transform Button */}
        <div className="flex justify-center mt-12">
          <motion.button
            onClick={handleTransform}
            // relative px-8 py-4 bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600 text-white rounded-2xl shadow-2xl overflow-hidden group
            className="Watch_Transform_Class"
            whileHover={{
              scale: 1.05,
              boxShadow: "0 20px 40px rgba(139, 92, 246, 0.4)",
            }}
            whileTap={{ scale: 0.95 }}
          >
            {/* Animated gradient overlay */}
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600"
              animate={{
                x: ["0%", "100%", "0%"],
              }}
              transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
              style={{ opacity: 0.5 }}
            />
  {/* relative z-10 flex items-center gap-3 text-lg font-semibold */}
            <span className="Watch_Transform_Class_btn">
              <Sparkles className="w-6 h-6" />
              Watch The Transformation
              <motion.div
                animate={{ x: [0, 5, 0] }}
                transition={{ duration: 1, repeat: Infinity }}
              >
                <ArrowRight className="w-6 h-6" />
              </motion.div>
            </span>

            {/* Particle effects */}
            {[...Array(8)].map((_, i) => (
              <motion.div
                key={i}
                className="absolute w-1 h-1 bg-white rounded-full"
                style={{
                  left: `${10 + i * 12}%`,
                  top: "50%",
                }}
                animate={{
                  y: [0, -20, 0],
                  opacity: [0, 1, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 0.2,
                }}
              />
            ))}
          </motion.button>
        </div>
      </motion.div>

      {/* 🎬 FULL-SCREEN TRANSFORMATION MODAL */}
      <AnimatePresence>
        {showTransformation && (
          <motion.div
            className="fixed inset-0 z-[200] bg-black/80 backdrop-blur-xl flex items-center justify-center p-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Close button */}
            <motion.button
              onClick={() => setShowTransformation(false)}
              className="absolute top-8 right-8 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm border border-white/20 z-10"
              whileHover={{ scale: 1.1, rotate: 90 }}
              whileTap={{ scale: 0.9 }}
            >
              <XIcon className="w-6 h-6 text-white" />
            </motion.button>

            {/* Transformation Stage */}
            <div className="relative w-full max-w-6xl h-[600px]">
              {/* Animated Team Members */}
              {teamMembers.map((member, index) => {
                const startPos = scatteredPositions[index];
                const endPos = organizedPositions[index];

                return (
                  <motion.div
                    key={member.id}
                    className="absolute"
                    initial={{
                      left: startPos.x,
                      top: startPos.y,
                      transform: "translate(-50%, -50%)",
                    }}
                    animate={{
                      left: transformationComplete
                        ? endPos.x
                        : [startPos.x, endPos.x],
                      top: transformationComplete
                        ? endPos.y
                        : [startPos.y, endPos.y],
                    }}
                    transition={{
                      duration: 2,
                      delay: 0.5 + index * 0.1,
                      type: "spring",
                      stiffness: 60,
                      damping: 15,
                    }}
                  >
                    <motion.div
                      className={`w-20 h-20 rounded-full bg-gradient-to-br ${member.color} flex items-center justify-center text-white text-xl font-bold shadow-2xl border-4 border-white relative`}
                      animate={{
                        scale: [1, 1.2, 1],
                        boxShadow: [
                          "0 10px 40px rgba(0,0,0,0.3)",
                          "0 20px 60px rgba(139, 92, 246, 0.6)",
                          "0 10px 40px rgba(0,0,0,0.3)",
                        ],
                      }}
                      transition={{
                        duration: 0.8,
                        delay: 1 + index * 0.1,
                      }}
                    >
                      {member.name}

                      {/* Motion trail */}
                      <motion.div
                        className="absolute inset-0 rounded-full bg-white/30"
                        initial={{ scale: 1, opacity: 0 }}
                        animate={{ scale: 2, opacity: [0, 0.5, 0] }}
                        transition={{
                          duration: 1,
                          delay: 0.5 + index * 0.1,
                          repeat: 2,
                        }}
                      />
                    </motion.div>

                    {/* Sparkle trail */}
                    {[...Array(3)].map((_, i) => (
                      <motion.div
                        key={i}
                        className="absolute w-2 h-2 bg-yellow-400 rounded-full"
                        style={{
                          left: "50%",
                          top: "50%",
                        }}
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{
                          scale: [0, 1, 0],
                          opacity: [0, 1, 0],
                          x: [(Math.random() - 0.5) * 100],
                          y: [(Math.random() - 0.5) * 100],
                        }}
                        transition={{
                          duration: 1,
                          delay: 0.8 + index * 0.1 + i * 0.2,
                        }}
                      />
                    ))}
                  </motion.div>
                );
              })}

              {/* Connecting Lines Animation */}
              <svg className="absolute inset-0 w-full h-full pointer-events-none">
                <defs>
                  <linearGradient
                    id="transformGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop offset="0%" stopColor="#EF4444" />
                    <stop offset="50%" stopColor="#8B5CF6" />
                    <stop offset="100%" stopColor="#3B82F6" />
                  </linearGradient>
                </defs>

                {/* Animated lines from center */}
                {organizedPositions.slice(0, 7).map((pos, index) => (
                  <motion.line
                    key={index}
                    x1="50%"
                    y1="50%"
                    x2={pos.x}
                    y2={pos.y}
                    stroke="url(#transformGradient)"
                    strokeWidth="3"
                    initial={{ pathLength: 0, opacity: 0 }}
                    animate={{
                      pathLength: 1,
                      opacity: [0, 0, 0.8, 0.8],
                      strokeWidth: [1, 3, 2],
                    }}
                    transition={{
                      duration: 2,
                      delay: 2 + index * 0.15,
                      times: [0, 0.3, 0.7, 1],
                    }}
                  />
                ))}
              </svg>

              {/* Center Burst Effect */}
              <motion.div
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                initial={{ scale: 0, opacity: 0 }}
                animate={{
                  scale: [0, 3, 2],
                  opacity: [0, 1, 0.8],
                }}
                transition={{ duration: 1.5, delay: 2 }}
              >
                <motion.div
                  className="w-32 h-32 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 blur-3xl"
                  animate={{
                    scale: [1, 1.5, 1],
                    opacity: [0.5, 1, 0.5],
                  }}
                  transition={{ duration: 2, repeat: Infinity }}
                />
              </motion.div>

              {/* Confetti Burst */}
              {transformationComplete && (
                <>
                  {[...Array(50)].map((_, i) => (
                    <motion.div
                      key={i}
                      className="absolute w-3 h-3 rounded-full"
                      style={{
                        background: [
                          "#f43f5e",
                          "#8b5cf6",
                          "#3b82f6",
                          "#06b6d4",
                          "#10b981",
                        ][i % 5],
                        left: "50%",
                        top: "50%",
                      }}
                      initial={{ scale: 0, opacity: 1 }}
                      animate={{
                        x: (Math.random() - 0.5) * 800,
                        y: (Math.random() - 0.5) * 600,
                        scale: [0, 1.5, 0],
                        opacity: [1, 1, 0],
                        rotate: Math.random() * 720,
                      }}
                      transition={{ duration: 2, ease: "easeOut" }}
                    />
                  ))}
                </>
              )}

              {/* Success Message */}
              <AnimatePresence>
                {transformationComplete && (
                  <motion.div
                    className="absolute top-8 right-8"
                    initial={{ opacity: 0, x: 400, y: -50, scale: 0.5 }}
                    animate={{ opacity: 1, x: 0, y: 0, scale: 1 }}
                    exit={{ opacity: 0, x: 400, y: -50 }}
                    transition={{
                      type: "spring",
                      stiffness: 200,
                      damping: 20,
                      duration: 0.6,
                    }}
                  >
                    <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3">
                      <motion.div
                        animate={{ scale: [1, 1.3, 1], rotate: [0, 360] }}
                        transition={{ duration: 0.6 }}
                      >
                        <CheckCircle2 className="w-8 h-8" />
                      </motion.div>
                      <div>
                        <div className="font-bold text-xl">Team Aligned!</div>
                        <div className="text-sm text-white/90">
                          Perfect synchronization achieved
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
